import { ActionContext, ActionTree } from 'vuex';
import { RootState, SignUpState } from '../../types';
import { SignUpErrors } from './types';
import { UserData } from '@/models/user';
import userService from '@/services/user.service';

const actions: ActionTree<SignUpState, RootState> = {
  async createAccount(
    store: ActionContext<SignUpState, RootState>,
    invitation: string
  ): Promise<UserData | SignUpErrors> {
    return userService
      .post(store.state, invitation)
      .then(response => response)
      .catch(error => {
        throw error;
      });
  },
};

export default actions;
